/**
 * Hero review cards strip — ported from techhunk.pk's slider behaviour.
 * - Real reviews: read from Judge.me's snapshot inside [data-th-review-cards] .th-review-source (only when data-real="true").
 * - Sample reviews (preview themes only) are rendered by Liquid; this file just wires up the dots.
 */
(function () {
  function clean(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function stars(score) {
    var rating = Math.round(parseFloat(score || 5));
    var out = '';
    for (var i = 1; i <= 5; i++) out += i <= rating ? '★ ' : '☆ ';
    return out.trim();
  }

  function collectReal(root) {
    var reviews = [];
    var seen = {};
    root.querySelectorAll('.jdgm-rev').forEach(function (review) {
      var bodyEl = review.querySelector('.jdgm-rev__body') || review.querySelector('.jdgm-rev__content');
      var body = clean(bodyEl ? bodyEl.textContent : '');
      if (body.length < 8 || seen[body.slice(0, 80)]) return;
      seen[body.slice(0, 80)] = true;

      var authorEl = review.querySelector('.jdgm-rev__author');
      var ratingEl = review.querySelector('.jdgm-rev__rating');
      reviews.push({
        body: body,
        author: clean(authorEl ? authorEl.textContent : '') || 'Customer',
        rating: (ratingEl && ratingEl.getAttribute('data-score')) || review.getAttribute('data-score') || 5,
        verified: review.getAttribute('data-verified-buyer') === 'true'
      });
    });
    return reviews;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function buildDots(root) {
    var slider = root.querySelector('[data-th-slider]');
    var dots = root.querySelector('[data-th-dots]');
    var cards = slider.querySelectorAll('.th-review-card');
    dots.innerHTML = '';

    cards.forEach(function (card, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Review ' + (index + 1));
      if (index === 0) dot.classList.add('active');
      dot.addEventListener('click', function () {
        slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft - 14, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });

    if (slider.dataset.dotsBound === 'true') return;
    slider.dataset.dotsBound = 'true';
    slider.addEventListener('scroll', function () {
      var list = slider.querySelectorAll('.th-review-card');
      var all = dots.querySelectorAll('button');
      var closest = 0;
      var best = Infinity;
      list.forEach(function (card, i) {
        var d = Math.abs(slider.scrollLeft - card.offsetLeft + slider.offsetLeft + 14);
        if (d < best) { best = d; closest = i; }
      });
      all.forEach(function (dot, i) { dot.classList.toggle('active', i === closest); });
    }, { passive: true });
  }

  function hideStrip(root) {
    var divider = root.previousElementSibling;
    if (divider && divider.classList.contains('th-review-divider')) divider.hidden = true;
    root.hidden = true;
  }

  // Picks a natural-looking mix of ratings instead of "first N" (which, on a mostly-5-star
  // product, ends up showing 5.0 in every card and reads as fake). Cycles through the distinct
  // rating values present so different scores are represented, then shuffles the pick and order.
  function pickDiverse(reviews, count) {
    var buckets = {};
    var order = [];
    reviews.forEach(function (r) {
      var key = Math.round(parseFloat(r.rating) || 5);
      if (!buckets[key]) { buckets[key] = []; order.push(key); }
      buckets[key].push(r);
    });
    order.sort(function (a, b) { return b - a; });

    var picked = [];
    var i = 0;
    while (picked.length < count && order.length) {
      var key = order[i % order.length];
      var bucket = buckets[key];
      if (bucket.length) {
        picked.push(bucket.splice(Math.floor(Math.random() * bucket.length), 1)[0]);
      } else {
        order.splice(i % order.length, 1);
        continue;
      }
      i++;
    }

    for (var j = picked.length - 1; j > 0; j--) {
      var k = Math.floor(Math.random() * (j + 1));
      var t = picked[j]; picked[j] = picked[k]; picked[k] = t;
    }
    return picked;
  }

  function fetchReal(root) {
    var url =
      'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(root.dataset.shopUrl || location.hostname) +
      '&shop_domain=' + encodeURIComponent(root.dataset.shopDomain || '') +
      '&platform=shopify&page=1&per_page=30&product_id=' + encodeURIComponent(root.dataset.productId || '');
    return fetch(url)
      .then(function (res) { return res.ok ? res.json() : { reviews: [] }; })
      .then(function (data) {
        var seen = {};
        return (data.reviews || [])
          .map(function (r) {
            return {
              body: clean(r.body_html),
              author: r.reviewer_name || 'Customer',
              rating: r.rating || 5,
              verified: !!r.verified_buyer
            };
          })
          .filter(function (r) {
            var key = r.body.slice(0, 80);
            if (r.body.length < 8 || seen[key]) return false;
            seen[key] = true;
            return true;
          });
      })
      .catch(function () { return []; });
  }

  function renderReal(root, slider, reviews) {
    var title = root.dataset.productTitle;
    var image = root.dataset.productImage;
    slider.innerHTML = '';
    reviews.forEach(function (review) {
      var rating = parseFloat(review.rating || 5);
      var card = document.createElement('div');
      card.className = 'th-review-card';
      card.innerHTML =
        '<div class="th-review-top">' +
          (image ? '<img src="' + image + '" alt="' + escapeHtml(title) + '" class="th-review-img" width="48" height="48">' : '') +
          '<div><h3>' + escapeHtml(title) + '</h3>' +
          '<div class="th-stars">' + stars(rating) + ' <span>(' + rating.toFixed(1) + ')</span></div>' +
          (review.verified ? '<div class="th-verified">✓ Verified Purchase</div>' : '') +
          '</div></div>' +
        '<p class="th-review-text">"' + escapeHtml(review.body) + '"</p>' +
        '<div class="th-review-footer"><span>- ' + escapeHtml(review.author) + '</span></div>';
      slider.appendChild(card);
    });
    buildDots(root);
    root.dataset.ready = 'true';
  }

  function init(root) {
    if (root.dataset.ready === 'true' || root.dataset.loading === 'true') return;
    var slider = root.querySelector('[data-th-slider]');
    if (!slider) return;

    if (root.dataset.real === 'true') {
      root.dataset.loading = 'true';
      fetchReal(root).then(function (reviews) {
        if (!reviews.length) {
          var source = root.querySelector('.th-review-source');
          reviews = source ? collectReal(source) : [];
        }
        if (!reviews.length) {
          hideStrip(root);
          return;
        }
        renderReal(root, slider, pickDiverse(reviews, Math.min(5, reviews.length)));
      });
      return;
    }

    buildDots(root);
    root.dataset.ready = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-th-review-cards]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') initAll();
})();
